import { clearingApi } from "../../config/apiConfig";

export const getEasybillRateLimitUsage = async () => {
  const response = await clearingApi.get(
    "api/v1/easybill/rate-limit/current-usage"
  );
  return response.data;
};
